import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const from = ['"What am I teaching tomorrow?"', 'Searching across multiple resources', 'Building every class from zero', 'Repeating the same exercises', 'Creating circuits manually', 'Improvising progressions', 'Spending personal time planning'];
const to = ['Visual exercises ready to explore', 'Complete classes ready to select', 'Professional circuits and stations', 'Strength and functional workouts', 'Balance and coordination activities', 'Clear progression options', 'Long-term programming', 'One organized coaching system'];
const alreadyWaiting = ['An exercise.', 'A class.', 'A circuit.', 'A progression.', 'A longer-term plan.'];
export function TransformSection() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-220" data-mp="1spt8cvwe7tvq">
      <div className="max-w-3xl mx-auto" data-id="element-221" data-mp="1srmiil67sw8h">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-3.5" data-id="element-222" data-mp="1xp5wdjz036zw">
          Think about your next 4 weeks of classes.
        </h2>

        <div className="text-[13px] sm:text-base text-petrol/70 leading-relaxed text-center max-w-xl mx-auto mb-3" data-id="element-223" data-mp="19ne4dqoicpec">
          <p data-id="element-224" data-mp="1nn6r7awwylh1">You could keep searching for exercises.</p>
          <p data-id="element-225" data-mp="1inkcsy5cmz6n">Building sessions one by one.</p>
          <p data-id="element-226" data-mp="1imj2wx02kiqi">Trying to create new circuits.</p>
          <p data-id="element-227" data-mp="1wn24pmdxysk8">Organizing progressions manually.</p>
          <p data-id="element-228" data-mp="1wlr0xmkhxkt4">Finding ways to keep classes varied.</p>
          <p data-id="element-229" data-mp="1slqdjcff5z9x">And repeating the same process again next month.</p>
        </div>

        <p className="font-heading font-black uppercase text-sm text-green-dark text-center mb-2" data-id="element-230" data-mp="1sjnpuz1qoi8d">
          Or...
        </p>

        <p className="text-[13px] sm:text-base text-petrol/70 leading-relaxed text-center max-w-xl mx-auto mb-3" data-id="element-231" data-mp="21e1zakzl8yjk">
          You could open one organized system and already have a professional
          starting point waiting for you.
        </p>

        <ul className="flex flex-wrap justify-center gap-1.5 mb-4" data-id="element-232" data-mp="2bdj83ba4zsjr">
          {alreadyWaiting.map(item => <li key={item} className="rounded bg-white border border-petrol/10 px-2 py-1 text-[10px] sm:text-xs font-semibold text-petrol/70" data-id="element-233" data-mp="2id38wt91ei6b">
              {item}
            </li>)}
        </ul>

        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight text-green-dark text-center mb-6" data-id="element-234" data-mp="2x4kfp6g3hv0g">
          That's what Fitness Senior Ready™ changes.
        </p>

        <div className="grid grid-cols-2 gap-2.5" data-id="element-235" data-mp="3647k8144fgxq">
          <div className="bg-white border border-petrol/10 rounded-lg p-3.5 sm:p-5" data-id="element-236" data-mp="362xnbf908eso">
            <h3 className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.14em] text-petrol/40 mb-2.5 pb-2 border-b border-petrol/10" data-id="element-237" data-mp="3b4d4uxbz436b">
              From:
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-238" data-mp="1grdlqu8dwqua">
              {from.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-239" data-mp="1lpotmzf4cr9v">
                  <XIcon className="w-3 h-3 text-petrol/35 mt-0.5 shrink-0" data-id="element-240" data-mp="1e5wf6q229yo7" />
                  <span className="text-[11px] sm:text-sm text-petrol/60 leading-snug" data-id="element-241" data-mp="19eo3fnd9e17v">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white border-2 border-green rounded-lg p-3.5 sm:p-5 shadow-md" data-id="element-242" data-mp="zgqfz23848gb">
            <h3 className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.14em] text-green-dark mb-2.5 pb-2 border-b border-green/20" data-id="element-243" data-mp="1x48l82xoesfk">
              To:
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-244" data-mp="1n62lnrzcdydv">
              {to.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-245" data-mp="1n7vw7id2t2r5">
                  <CheckIcon className="w-3 h-3 text-green mt-0.5 shrink-0" data-id="element-246" data-mp="1i6g97krc8m64" />
                  <span className="text-[11px] sm:text-sm font-medium text-petrol leading-snug" data-id="element-247" data-mp="bryuetk52oci">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}